import { render, staticRenderFns } from "./Chatinator.vue?vue&type=template&id=73fc795c&scoped=true&"
import script from "./Chatinator.vue?vue&type=script&lang=js&"
export * from "./Chatinator.vue?vue&type=script&lang=js&"
import style0 from "./Chatinator.vue?vue&type=style&index=0&id=73fc795c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc795c",
  null
  
)

export default component.exports